import React, { useEffect, useState } from 'react';
import { Card, Col, Modal, Row, Table } from 'react-bootstrap';
import './styles.scss';
import { authServices } from 'Utils/auth/services';
import { settingServices } from 'Utils/setting/services';
import ToggleSwitch from 'Common/ToggleSwitch';
import moment from 'moment';
import Loader from 'Common/Loader';

interface UserDetailsModalProps {
    show: boolean;
    onHide: () => void;
    selectedUser: any;
    userDetails: any;
}

const UserDetailsModal: React.FC<UserDetailsModalProps> = ({ show, onHide, selectedUser, userDetails }) => {
    const [userData, setUserData] = useState<any>(null);
const [userLockStatus,setUserLockStatus ] = useState([])
const [gameLockList,setGameLockList ] = useState([])
    const getUserBalance = async () => {
        try {
            const { response } = await authServices.showBalance({ user_id: String(selectedUser?._id) });
            const data = response?.data || {};
            setUserData(data);
        } catch (error) {
            console.error("Error fetching user balance:", error);
        }
    };
    const getUplineLockStatus = async () => {
        try {
            const { response } = await authServices.getUserUplineLockStatus({ user_id: String(selectedUser?._id) });
            const data = response?.data || {};
            setUserLockStatus(data);
        } catch (error) {
            console.error("Error fetching user balance:", error);
        }
    };
    const getDiamondGamesLockList = async () => {
        try {
            const { response } = await authServices.diamondGamesLockList({ user_id: String(selectedUser?._id) });
            const data = response?.data || {};
            setGameLockList(data);
        } catch (error) {
            console.error("Error fetching user balance:", error);
        }
    };


    useEffect(() => {

        if (selectedUser?._id) {
            getUserBalance();
            getUplineLockStatus()
            getDiamondGamesLockList()
        }
    }, [selectedUser]);

    const getUserTypeLabel = (typeId: number): string => {
        switch (typeId) {
            case 8: return 'White Label';
            case 7: return 'Sub Admin';
            case 6: return 'Hyper';
            case 5: return 'Admin';
            case 4: return 'Super Master';
            case 3: return 'Master';
            case 2: return 'Agent';
            default: return 'User';
        }
    };
    const [isLoading,setIsLoading] = useState(false)
    const [marketData,setMarketData] = useState<any>()
      const [toggleStates, setToggleStates] = useState<{ [key: string]: boolean }>({});
    
  const getEventAnylysis = async () => {
    const { response } = await settingServices.getEventAnylysis2(
       { user_id:selectedUser?._id}
    );
    setIsLoading(false);
    if(response && response?.data)
    setMarketData(response?.data || {});
  };
  const handleToggleChange = (marketKey: string) => {
    setToggleStates((prevStates) => ({
      ...prevStates,
      [marketKey]: !prevStates[marketKey], 
    }));
  };

  useEffect(()=>{
    getEventAnylysis()
  },[])
    return (
        <>
            <div className="modal-section">
                {/* Left Box */}
                <div className="left-box">
                    <div className="title">Game Detail</div>
                    <div className="detail shad">
                        <div><strong>Username:</strong> {userData?.user_name || '-'}</div>
                        <div><strong>Account Type:</strong> {getUserTypeLabel(userData?.user_type_id)}</div>
                        <div><strong>General:</strong> {userData?.balance}</div>
                        <div><strong>Exposure:</strong> {-Number(userData?.liability)}</div>
                        <div><strong>Credit Reference:</strong> {userData?.credit_reference}</div>
                    </div>
                </div>

                {/* Center Box */}
                <div className="center-box">
                    <div className="title">User Lock</div>
                    <div className="detail">
                        <Table bordered size="sm">
                            <thead>
                                <tr>
                                    <th>Master Name</th>
                                    <th>User Act</th>
                                    <th>Bet Active</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userLockStatus?.map((lock: any, idx: number) => (
                                    <tr key={idx}>
                                        <td>{lock.name}</td>
                                        <td><input type="checkbox" checked={lock.lock_user == 0? true:false} readOnly /></td>
                                        <input type="checkbox" checked={!(lock?.lock_betting === 1 || lock?.lock_fancy_bet === 1)} readOnly />

                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>

                {/* Right Box */}
                <div className="right-box">
                    <div className="title">Game Lock</div>
                    <div className="detail">
                        <Table bordered size="sm">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Master Name</th>
                                    <th>Bet Lock</th>
                                    <th>Event Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {gameLockList?.map((item:any,i:number)=>{
                                    return(

                                <tr>
                                    <td>{i+1}</td>
                                    <td>{item?.parent_user_name}</td>
                                    <td><input type="checkbox"  readOnly defaultChecked/></td>
                                    <td>{item?.series_name}</td>
                                </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {/* Match Section */}
            <div className="match-section">
            {marketData &&
            Object?.keys(marketData)?.map((keys) => {
              return (
                <>
                  {/* <h5 className="p-2 mb-1 text-primary">{keys}</h5> */}
                  {marketData &&
                    marketData[keys]?.map((items: any) => {
                      return (
                        <Card key={items?.match_id}>
                          <Card.Header className="bg-light py-2 title">
                            <Row className="justify-content-between">
                              <Col lg={8} xs={12}>
                                <strong className="fs-lg">
                                  {items?.match_name}
                                  <ToggleSwitch
                                    On="S"
                                    Off="F"
                                    id={items?.match_name}
                                    className="ms-2"
                                    onChange={() => handleToggleChange(items?.match_name)}
                                    checked={!toggleStates[items?.match_name] || false}
                                  />
                                </strong>
                              </Col>
                              <Col
                                lg={4}
                                xs={12}
                                className="text-start text-lg-end"
                              >
                                {moment(items?.match_date)?.format(
                                  "DD-MM-YYYY hh:mm:ss:SSS A"
                                )}
                              </Col>
                            </Row>
                          </Card.Header>
                          <Card.Body>
                            <Row className="g-3">
                              {items?.markets &&
                                Object?.keys(items?.markets)
                                  ?.sort((a, b) => {
                                    if (a.split("|")[0] === "MATCH_ODDS") return -1;
                                    if (b.split("|")[0] === "MATCH_ODDS") return 1;
                                    return a.localeCompare(b);
                                  })
                                  ?.map((market) => {
                                    const name = market?.split("|")[0];
                                    return (
                                      <Col
                                        lg={4}
                                        key={market}
                                        // onClick={() =>
                                        //   handleRoute(
                                        //     items?.match_id,
                                        //     "4",
                                        //     1,
                                        //     items?.match_name,
                                        //     0
                                        //   )
                                        // }
                                      >
                                        <h5 className="series-name">{name?.split("_").join(" ")}</h5>
                                        <div
                                          className="table-responsive border"
                                          style={{ maxHeight: "180px" }}
                                        >
                                          <Table className="table-striped-columns mb-0">
                                            <tbody>
                                              {items?.markets[market]?.map(
                                                (marketDataList: any) => {
                                                  const labVal = !toggleStates[items?.match_name]
                                                    ? marketDataList?.win_loss
                                                    : marketDataList?.win_loss_total_exposure;
                                                  return (
                                                    <tr
                                                      key={marketDataList?.selection_name}
                                                    >
                                                      <td>
                                                        {marketDataList?.selection_name}
                                                      </td>
                                                      <td
                                                        className={`${
                                                          labVal < 0
                                                            ? "text-danger"
                                                            : "text-secondary"
                                                        } text-center`}
                                                      >
                                                        {labVal}
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </Col>
                                    );
                                  })}

                              {items?.fancies &&
                                Object?.keys(items?.fancies)?.map((fancies) => {
                                  return (
                                    <Col lg={4} key={fancies} 
                                    // onClick={() =>
                                    //   handleRoute(
                                    //     items?.match_id,
                                    //     "4",
                                    //     1,
                                    //     items?.match_name,
                                    //     0
                                    //   )
                                    
                                    // }
                                    >
                                      <h5>{fancies?.split("|")[0]}</h5>
                                      <div
                                        className="table-responsive border"
                                        style={{ maxHeight: "180px" }}
                                      >
                                        <Table className="table-striped-columns mb-0">
                                          <tbody>
                                            {items?.fancies[fancies]?.map(
                                              (marketDataList: any) => {
                                                const fancy_lab =
                                                  !toggleStates[items?.match_name]
                                                    ? marketDataList?.liability
                                                    : marketDataList?.liability_total;
                                                return (
                                                  <tr key={marketDataList?.fancy_name}>
                                                    <td>
                                                      {marketDataList?.fancy_name}
                                                    </td>
                                                    <td
                                                      className={`${
                                                        fancy_lab < 0
                                                          ? "text-danger"
                                                          : "text-secondary"
                                                      } text-center`}
                                                    >
                                                      {fancy_lab}
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            )}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </Col>
                                  );
                                })}
                            </Row>
                          </Card.Body>
                        </Card>
                      );
                    })}
                </>
              );
            })}

          {isLoading && <Loader />}
            </div>
        </>
    );
};

export default UserDetailsModal;
